import React, { useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export function useNavigationGuard(isEdited: boolean, message: string) {
  const { navigator } = React.useContext(NavigationContext);

  useEffect(() => {
    if (!isEdited) return;

    const push = navigator.push;
    const replace = navigator.replace;

    navigator.push = (...args: Parameters<typeof push>) => {
      if (window.confirm(message)) {
        push(...args);
      }
    };

    navigator.replace = (...args: Parameters<typeof replace>) => {
      if (window.confirm(message)) {
        replace(...args);
      }
    };

    return () => {
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [isEdited, message, navigator]);
}
